import { Typography } from "@mui/material"


const ProfessionalCovenants = ({ covenants, fontSize = 12 }) => {
    return (
        <>
            <Typography style={{ fontWeight: 'bold', fontSize: fontSize }}>
                Convenios:
            </Typography>
            <Typography style={{ fontWeight: 500, fontSize: fontSize }}>
                {!covenants || covenants?.length === 0 ? `Sin convenios` : covenants.map(el => el.isaNombre).join(", ")}
            </Typography>

        </>
    )
}

export default ProfessionalCovenants;